import { useEffect, useState } from 'react';
import { Link, useParams } from 'react-router-dom';
import { Header } from '../components/Header';
import { Footer } from '../components/Footer';
import { SeoHead } from '../components/SeoHead';
import { formatTl } from '../constants/storePolicies';

const API_URL = window.location.hostname === 'localhost'
  ? 'http://localhost:5000'
  : 'https://kiyafet-magazasi-backend.vercel.app';

function slugify(text = '') {
  return String(text)
    .toLowerCase()
    .replace(/ğ/g, 'g').replace(/ü/g, 'u').replace(/ş/g, 's')
    .replace(/ı/g, 'i').replace(/ö/g, 'o').replace(/ç/g, 'c')
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/^-+|-+$/g, '');
}

export function CategoryPage() {
  const { slug } = useParams();
  const [categoryName, setCategoryName] = useState('');
  const [products, setProducts] = useState<any[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    setLoading(true);
    Promise.all([
      fetch(`${API_URL}/api/kategoriler`).then((r) => r.json()),
      fetch(`${API_URL}/api/urunler`).then((r) => r.json()),
    ])
      .then(([cats, urunler]) => {
        const list = Array.isArray(cats) ? cats : [];
        const productsList = Array.isArray(urunler) ? urunler : (urunler?.urunler || []);
        const cat = list.find((c: any) => slugify(c.ad) === slug);
        const name = cat?.ad || '';
        setCategoryName(name);
        setProducts(name ? productsList.filter((p: any) => p.kategori === name) : []);
        setLoading(false);
      })
      .catch(() => setLoading(false));
  }, [slug]);

  const title = categoryName ? `${categoryName} | Ladiora Boutique` : 'Kategori | Ladiora Boutique';
  const description = categoryName
    ? `${categoryName} kategorisindeki ürünleri keşfedin. Ladiora Boutique online mağaza.`
    : 'Ladiora Boutique kategorileri';

  return (
    <div className="min-h-screen bg-white flex flex-col">
      <SeoHead title={title} description={description} />
      <Header />
      <main className="flex-1 max-w-7xl mx-auto px-4 py-12 w-full">
        <nav className="text-sm text-gray-500 mb-6">
          <Link to="/" className="hover:text-pink-600">Ana Sayfa</Link>
          <span className="mx-2">/</span>
          <span className="text-gray-900">{categoryName || 'Kategori'}</span>
        </nav>
        <h1 className="text-3xl md:text-4xl font-bold text-gray-900 mb-8">{categoryName || 'Kategori'}</h1>

        {loading ? (
          <p className="text-gray-500">Yükleniyor...</p>
        ) : products.length === 0 ? (
          <p className="text-gray-500">Bu kategoride ürün bulunamadı.</p>
        ) : (
          <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-6">
            {products.map((p) => (
              <Link key={p.id} to={`/urun/${p.id}`} className="group">
                <div className="aspect-[3/4] overflow-hidden bg-gray-100 mb-3">
                  <img
                    src={p.resimler?.[0] || ''}
                    alt={p.ad}
                    className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                  />
                </div>
                <h2 className="font-medium text-gray-900 group-hover:text-pink-600">{p.ad}</h2>
                <p className="text-gray-700">{formatTl(Number(p.fiyat || 0))}</p>
              </Link>
            ))}
          </div>
        )}
      </main>
      <Footer />
    </div>
  );
}
